import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter as Router } from "react-router-dom"
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import awsConfig from './aws-config.js';
import Amplify from 'aws-amplify';

Amplify.configure(awsConfig);
ReactDOM.render(
	<Router>
		<App />
	</Router>
	, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js